import React from 'react';
import { Alert } from '@mui/material';

/**
 * Warns when a coordinate lookup came back as an approximate ("closest") match —
 * i.e. the name resolver (SIMBAD/Sesame) matched loosely and the typed query is NOT
 * one of the resolved object's real identifiers (e.g. "V Sgexx" -> "V Sge"). The
 * coordinates are still shown/usable; this puts the mismatch in front of the user so
 * a typo doesn't silently become a different target. Renders nothing for exact matches.
 */
export default function ApproximateMatchNotice({ result, query, sx }) {
  if (!result?.approximateMatch) return null;
  const resolved = result.resolvedName || 'the returned object';
  const typed = (query || result.objectName || '').trim();
  return (
    <Alert severity="warning" sx={{ py: 0.25, ...sx }}>
      {typed ? <>“{typed}” is not a catalog identifier for </> : 'This is not an exact match for '}
      <strong>{resolved}</strong> — this is the closest match the resolver returned.
      Verify it is the object you intended before using these coordinates.
    </Alert>
  );
}
